import { render, staticRenderFns } from "./EmergencyMessages.vue?vue&type=template&id=044bead8&scoped=true&"
import script from "./EmergencyMessages.vue?vue&type=script&lang=js&"
export * from "./EmergencyMessages.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyMessages.vue?vue&type=style&index=0&id=044bead8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044bead8",
  null
  
)

export default component.exports